/* eslint-disable import/no-anonymous-default-export */
import apiCall from "./apiCall";

export default {
  async login(username, password) {
    const data = {
      username: username,
      password: password
    };
    return await apiCall("central/watchman/login", data);
  },

  async resetPassword(password) {
    const data = {
      password: password,
    };
    return await apiCall("central/watchman/new_password", data);
  },

  async sendPasswordResetCode(username) {
    const data = {
      email_address: username
    };
    return await apiCall("central/watchman/forgot_password", data);
  },

  async verifyPasswordResetCode(username, code) {
    const data = {
      email_address: username,
      code: code
    };
    return await apiCall("central/watchman/verify_password_reset", data);
  },

  async captiveLogin(username, password) {
    const data = {
      username: username,
      password: password
    };
    return await apiCall("login/captive", data);
  },
  async fetchPermissions(){
    return await apiCall("user/permission/list_permissions", []);
  },
   async fetchRolePermissions(roleid){
    const data = { role_id: roleid };
    return await apiCall("user/rolepermission/role_permissions", data);
  },
  async addRolePermissions(data){
    return await apiCall("user/rolepermission/add_permission", data);
  },
  async assignMultiPermissions(data){
    return await apiCall("user/rolepermission/multiple_assign_permissions", data);
  },
  async fetchMyPermissions() {
    return await apiCall("platform/webclient/my_permissions", []);
  },
   async revokeMultiPermissions(data){
    return await apiCall("user/rolepermission/revoke_multiple_access", data);
  },
  
  

};
